import React, { useState, useEffect, useRef } from "react";
import "../../assets/css/Home/header.css";
import user from "../../assets/images/home_icon/User.png"
import telegram from "../../assets/images/home_icon/Telegram.png"
import mail from "../../assets/images/home_icon/Mail.png"
import whatsapp from "../../assets/images/home_icon/Whatsapp.png"
import help from "../../assets/images/home_icon/help.png"
import mark from "../../assets/images/home_icon/question_mark.png"

function Header() {
  const [hovered, setHovered] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
 

  useEffect(() => {
    const handleScroll = () => {
      if (!showPopup) {
        setShowPopup(true);
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  

  return (
    <div className="container-fluid header-section bg-dark text-light">
      <div className="row">
        {/* First Part - Title, Explanation, and Buttons */}
        <div className="col-md-2"></div>
        <div className="col-md-5 d-flex flex-column justify-content-center align-items-start p-4">
          <p className="mb-3 header-title">
            Cyber Security Observatory Detection And Response And Network
            Monitoring Performance Observability In Any Hybrid Environment Solution
          </p>
          <p className="mb-4 header-comment">
            Ost Infinity ViXa Identity-First Managed Detection and Response and
            Network Monitoring, Managed Risk solution focusing on vulnerability
            assessment, Concierge Security Team (CST) extends your IT staff with
            security expertise on 24/7
          </p>
          <div className="d-flex flex-row align-items-start">
            <button className="btn btn-primary me-2">Learn More</button>
            <button className="btn btn-warning">Log in to ViXa</button>
          </div>
        </div>

        {/* Second Part - Logo, Comment, and Text */}
        <div className="col-md-4 d-flex flex-column justify-content-center align-items-center p-4 text-center">
          <img
            src="logo.png"
            alt="Logo"
            className="img-fluid mb-3"
            style={{ maxWidth: "150px" }}
          />
          <p className="h5 mb-2">VIXA PLATFORMS</p>
          <p className="text-muted">AIOps | Machine Learning</p>
        </div>

        {/* Empty Space (Optional to make the layout more flexible for mobile) */}
        <div className="col-md-1"></div>
      </div>

      {/* Bottom-Center Text and User Button */}
      <div className="text-center mt-4">
        <p>Text</p>
      </div>

      <div className="help-button">
        <img src={help} alt="Help" className="help-img" />
        <img src={mark} alt="Mark" className="mark-img" />
        <div className={`help-popup ${showPopup ? 'show' : ''}`}>
          <span className="popup-content">Live experts are online now to help you
          determine right solution.
          </span> 
          <span className="popup-content-out">Start Chat Now</span>
        </div>
      </div>


      <div
        className="user-button-container"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <button className="user-btn btn rounded-circle">
          <img src={user}></img>
        </button>

        {/* Social Buttons Group */}
        <div
          className={`social-buttons ${hovered ? "visible" : ""}`}
        >
          <button className="social-btn btn rounded-circle">
            <img src={whatsapp}></img>
          </button>
          <button className="social-btn btn rounded-circle">
            <img src={telegram}></img>
          </button>
          <button className="social-btn btn rounded-circle">
            <img src={whatsapp}></img>
          </button>
        </div>
      </div>
    </div>
  );
}

export default Header;
